module.exports = __webpack_public_path__ + "static/born-a-crime-f23c839d60a3b7d88e1fd9b11852bd30.jpg";